export const EU_IMPORT_DELIMITATION = 'enum.sale_delimitation.eu_import'
export const NON_EU_IMPORT_DELIMITATION = 'enum.sale_delimitation.non_eu_import'
export const IMPORT_ORIGIN_TOOLTIP_KEY = 'product.nonEuImport.tooltip'

const IMPORT_ORIGIN_KEYS = [EU_IMPORT_DELIMITATION, NON_EU_IMPORT_DELIMITATION] as const

export interface ImportOriginChip {
  labelKey: string
  tooltipKey: string
}

export const resolveImportOrigin = (
  saleDelimitations?: readonly string[] | null,
): ImportOriginChip[] => {
  if (!saleDelimitations?.length) return []

  const present = new Set(saleDelimitations)
  return IMPORT_ORIGIN_KEYS
    .filter(labelKey => present.has(labelKey))
    .map(labelKey => ({ labelKey, tooltipKey: IMPORT_ORIGIN_TOOLTIP_KEY }))
}
